<template>
 	<b-container fluid>
        <b-row class="page-title">
            <b-container fluid>
                <h3>Customer Sign Up Review</h3>
                <hr>
            </b-container>
        </b-row>
        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="tables.customers.filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                              debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!tables.customers.filter" @click="tables.customers.filter = ''">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="3" class="buttons-create">

                    </b-col>

                    <b-col class="text-center" cols="3">
                        <b-button v-if="tables.customers.hasQueryClicks" variant="danger" size="sm" @click="clearQueryClicks">Clear Filters</b-button>
                    </b-col>

                    <b-col cols="3">
                        <b-form-group>
                          <b-form-select
                            v-model="tables.customers.perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="tables.customers.pageOptions"
                          ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-customers-table">
                    <b-container fluid>
                        <b-table
                            :key="tables.customers.key"
                            class="customers-table"
                            responsive bordered
                            hover no-border-collapse
                            sticky-header="calc(100vh - 250px)"
                            head-variant="light"
                            :items="tables.customers.items" :fields="tables.customers.fields"
                            :sort-by="tables.customers.sortBy"
                            :sort-desc="tables.customers.sortDesc"
                            :per-page="tables.customers.perPage"
                            :current-page="tables.customers.currentPage"
                            :filter="tables.customers.filter"
                            @filtered="onFiltered"
                            :busy="tables.customers.isBusy"
                        >

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(created_at)="row">
                                <span v-if="row.item.created_at">{{ row.item.created_at | moment('MM-DD-YYYY') }}</span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(customers)="row">
                                <div v-if="row.item.customers.length" class="text-nowrap">
                                    <b-table-simple hover small responsive bordered>
                                        <b-tbody>
                                            <b-tr v-for="(match, index) in row.item.customers" :key="index">
                                                <td class="match-name-col">{{ match.name }}</td>
                                                <td class="text-center">{{ match.id }}</td>
                                            </b-tr>
                                        </b-tbody>
                                    </b-table-simple>
                                </div>
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <b-col>
                                            <b-link @click="verifyApprove(row.item)"><b-button size="sm" >Review</b-button></b-link>
                                        </b-col>
                                        <b-col>
                                            <b-link @click="boxConfirm('delete-row', row.item.name, row.item.id)"><b-button size="sm" variant="danger">Deny</b-button></b-link>
                                        </b-col>
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination
                          v-model="tables.customers.currentPage"
                          :total-rows="tables.customers.totalRows"
                          :per-page="tables.customers.perPage"
                          align="fill"
                          size="sm"
                          class="my-0"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-container>
        </b-row>

        <modal-approve-review
            v-if="modals['modal-customer-sign-up-review-approve'].active"
            :row="modals['modal-customer-sign-up-review-approve'].row"
            :matches="modals['modal-customer-sign-up-review-approve'].matches"
            @approveRow="approveRow"
        />
    </b-container>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ModalApproveReview from './modals/ApproveReview'
 	export default {
    	name: 'CustomerSignUpReview',

        metaInfo() {
            return {
                title: 'Customer Sign Up Review',
            }
        },

    	components: {
              Treeselect,
              'modal-approve-review': ModalApproveReview
    	},
        data() {
            return {
                modals: {
                    'modal-customer-sign-up-review-approve': {
                        active: 0,
                        row: []
                    }
                },
                tables: {
                    customers: {
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'created_at',
                        sortDesc: true,
                        filter: null,
                        key: 1,
                        fields: [
                            {
                                key: 'created_at',
                                label: 'Sign Up Date',
                                thClass: 'customers-table-style-th-datetime',
                                tdClass: 'customers-table-style-td-datetime',
                                sortable: true
                            },
                            {
                                key: 'email',
                                label: 'E-mail',
                                sortable: true
                            },
                            {
                                key: 'name',
                                label: 'Company Name',
                                sortable: true
                            },
                            {
                                key: 'buyers_name',
                                label: 'Buyers Name',
                                sortable: true
                            },
                            {
                                key: 'customers',
                                label: 'Existing',
                                sortable: true
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'customers-table-style-actions',
                                tdClass: 'text-center'
                            }
                        ],

                        items: [],
                    },
                },
            }
        },
        methods: {
            openModal(modalName, row, matches) {
                switch (modalName) {
                    case 'modal-customer-sign-up-review-approve':
                        this.modals[modalName].row = row
                        this.modals[modalName].matches = matches

                        break
                }

                this.modals[modalName].active = 1

                this.$nextTick(() => {
                    this.$bvModal.show(modalName)
                })
            },

            verifyApprove(row) {
                let matches = row.customers.length
                // if (!matches) {
                //     this.boxConfirm('approve-row', row.name, row.id)
                // } else {
                    this.openModal('modal-customer-sign-up-review-approve', row, matches)
                // }
            },

            boxConfirm(area, name, id) {
                let msg;
                let title;
                let variant;
                let okName;

                if (area == 'delete-row') {
                    msg = 'Please confirm that you want to deny application for: ' + name
                    title = 'Deny: ' + name
                    variant = 'danger'
                    okName = 'Deny'
                } else if (area == 'approve-row') {
                    msg = 'Please confirm that you want to approve application for: ' + name
                    title = 'Approve: ' + name
                    variant = 'success'
                    okName = 'Approve'
                }

                this.$bvModal.msgBoxConfirm(msg, {
                    title: title,
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: variant,
                    okTitle: okName,
                    cancelTitle: 'Cancel',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        if (area == 'delete-row') {
                            if (value) {
                                this.deleteRow(id)
                            }
                        } else if (area == 'approve-row') {
                            this.approveRow(id, '', 1)
                        }
                    }
                })
                .catch(err => {
                    // An error occurred
                })
            },

            deleteRow(id) {
                let url = 'api/lists/customers/review/delete/' + id
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.getCustomers(1)
                    }
                }, () => {
                    // this.has_error = true
                })
            },

            approveRow(rowId, selectedId, manualCustomerId, createNew) {
                let url = 'api/lists/customers/review/approve'
                axios.post(url, {
                    rowId: rowId,
                    selectedId: selectedId,
                    manualCustomerId: manualCustomerId,
                    createNew: createNew
                })
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.showAlertBox('success', 'Approved', 'Customer approved!')
                        this.getCustomers(1)
                    } else {
                        this.showAlertBox('error', 'Error', 'Issue occured. Please try again.')
                    }
                }, () => {
                    // this.has_error = true
                })
            },

            toggleBusy() {
                this.tables.customers.isBusy = !this.tables.customers.isBusy
            },

            getCustomers(silent) {
                if (!silent) {
                    this.toggleBusy()
                }

                let url = 'api/lists/customers/review/getcustomersignups'
                axios.post(url, {

                })
                .then((res) => {
                    if (res.data.success = 'success') {
                        this.tables.customers.items = res.data.customers
                        this.tables.customers.totalRows = this.tables.customers.items.length

                        if (!silent) {
                            this.toggleBusy()
                        }
                    }
                }, () => {
                    this.has_error = true
                })
            },

            onFiltered(filteredItems) {
                this.tables.customers.totalRows = filteredItems.length
                this.tables.customers.currentPage = 1
            }
        },
    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.customers.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.customers.totalRows
                let currentPage = this.tables.customers.currentPage
                let perPage = this.tables.customers.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.customers.totalRows + ' rows'
            }
	    },
	    mounted() {
            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-customer-sign-up-review-approve':
                        this.modals['modal-customer-sign-up-review-approve'].row = []
                        this.modals['modal-customer-sign-up-review-approve'].active = 0

                        break
                }
            })

            this.getCustomers()

            // pusher
            // Echo.channel('table-customer-updated')
            //     .listen('TableCustomerUpdated', (e) => {
            //         this.getCustomers(1)
            // })
	    }
  }
</script>
<style lang="scss">
    .vue-treeselect__control {
        font-size: 0.875rem !important;
    }

    .customers-table {
        height: 75vh;
        font-size: 9pt;

        .fa-check-square {
            color: green;
        }

        .fa-window-close {
            color: red;
        }

        .customers-table-style-actions {
            min-width: 120px;

            .actions-icons {
                text-align: center;
                white-space: nowrap;
            }
        }

        .customers-table-style-phone {
            min-width: 105px;
        }

        .customers-table-style-th-datetime {
            min-width: 110px;
        }

        .customers-table-style-td-datetime {
            text-align: center;
        }

        .match-name-col {
            width: 75%;
        }
    }
</style>
